import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const PrivateRoute = ({ roles = [], requirePasswordChange = false }) => {
  const { currentUser, userRole, mustChangePw } = useAuth();
  const location = useLocation();

  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If user must change password, redirect to change-password page
  // Exception: allow access to /change-password itself
  if (mustChangePw && location.pathname !== '/change-password' && !requirePasswordChange) {
    return <Navigate to="/change-password" replace />;
  }

  // If user doesn't need to change password but trying to access change-password page
  if (!mustChangePw && requirePasswordChange) {
    // Redirect to appropriate page based on role
    if (userRole === 'swandive') {
      return <Navigate to="/ops" replace />;
    }
    if (userRole === 'admin' || userRole === 'staff') {
      return <Navigate to="/threads" replace />;
    }
    return <Navigate to="/" replace />;
  }

  if (roles.length > 0 && !roles.includes(userRole)) {
    // Redirect based on user role
    if (userRole === 'swandive') {
      return <Navigate to="/ops" replace />;
    }
    if (userRole === 'admin' || userRole === 'staff') {
      return <Navigate to="/threads" replace />;
    }
    // Fallback to login if role is unrecognized
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};
